export const environment = {
  production: true,
  basePath: 'https://encuestas.certant.com/encuestasAPI'
};